// extracted by mini-css-extract-plugin
export default {"custom-modal-dialog":"SyncModal_custom-modal-dialog__k-GSJ","calender-modal":"SyncModal_calender-modal__vI97S","sync-link-div":"SyncModal_sync-link-div__JJa-J"};